/**
 * Cliente API de lotes.
 *
 * Sprint 12 S12-04: listLotes (selector admin).
 * Sprint 13 S13-11: crearLote + actualizarLote (mantenedor sa).
 */
import { apiFetch } from './client';
import type { LoteCreate, LoteResumen, LoteUpdate } from './types';

export function listLotes(opts: { activo?: boolean } = {}): Promise<LoteResumen[]> {
  const params = new URLSearchParams();
  if (opts.activo !== undefined) params.set('activo', String(opts.activo));
  const qs = params.toString();
  return apiFetch<LoteResumen[]>(`/lotes/${qs ? `?${qs}` : ''}`);
}

export function crearLote(data: LoteCreate): Promise<LoteResumen> {
  return apiFetch<LoteResumen>('/lotes/', {
    method: 'POST',
    body: JSON.stringify(data),
  });
}

export function actualizarLote(
  loteId: string,
  data: LoteUpdate,
): Promise<LoteResumen> {
  return apiFetch<LoteResumen>(`/lotes/${loteId}`, {
    method: 'PATCH',
    body: JSON.stringify(data),
  });
}

// Sprint 13 S13-16: import CSV.
export interface ImportCsvResultado {
  total_filas: number;
  creados: number;
  errores: { fila: number; error: string }[];
}

export function importLotesCsv(archivo: File): Promise<ImportCsvResultado> {
  const form = new FormData();
  form.append('archivo', archivo);
  return apiFetch<ImportCsvResultado>('/lotes/import-csv', {
    method: 'POST',
    body: form,
  });
}

// Sprint 13 S13-18: DELETE con guard de relaciones.
export function eliminarLote(loteId: string): Promise<void> {
  return apiFetch<void>(`/lotes/${loteId}`, { method: 'DELETE' });
}
